import { makeStyles } from "@material-ui/styles";
import * as React from "react";
import { DiagramEngine } from "@projectstorm/react-diagrams-core";
import {
  Theme,
  createStyles,
  Card,
  CardHeader,
  CardActions
} from "@material-ui/core";
import { t } from "../../../../../core/i18n/i18n";
import { DefaultTreeBlockModel } from "../DefaultTreeBlockModel";
import { PortsWrapper } from "./PortsWrapper";
import InfoTooltip from "../InfoTooltip";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: 8
    },
    actions: {
      padding: "5px 0"
    },
    node: {
      overflow: "visible",
      fontSize: "11px",
      "&:hover": {
        opacity: 0.9
      }
    }
  })
);

export interface TreeBlockWidgetProps {
  node: DefaultTreeBlockModel;
  engine: DiagramEngine;
}

export const TreeBlockWidget = (props: TreeBlockWidgetProps) => {
  const classes = useStyles();
  const BORDER_COLOR = "#00c0ff";

  const { node, engine } = props;
  return (
    <Card
      style={{
        border: node.isSelected() ? ` solid 2px ${BORDER_COLOR}` : ""
      }}
      className={classes.node}
      variant={"outlined"}
    >
      <div style={{ backgroundColor: node.color }}>
        <CardHeader
          classes={{ root: classes.root }}
          style={{
            backgroundImage:
              "linear-gradient(rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.1))"
          }}
          title={t(`hns:tree:treeBlock:${node.name}`)()}
          titleTypographyProps={{ variant: "subtitle1" }}
          subheader={`${node.config}`}
          subheaderTypographyProps={{ variant: "caption" }}
        />
        {node.meta.warning.length > 0 && (
          <InfoTooltip type="warning">
            {node.meta.warning.map((w: string, index: number) => (
              <Typography key={index} color="inherit">
                {t("hns:tree:treeBlock:meta:warning:" + w)()}
              </Typography>
            ))}
          </InfoTooltip>
        )}
        <CardActions classes={{ root: classes.actions }}>
          <PortsWrapper engine={engine} node={node} />
        </CardActions>
      </div>
    </Card>
  );
};
